import React from 'react'
import { useSelector } from 'react-redux'
import { eventSelector, eventModalSelector } from 'src/selectors'
import Flier from 'src/components/details/Flier'
import PropTypes from 'prop-types'

import ChatSection from './ChatSection/ChatSection'

import styles from './flyer-container.scss'

const FlyerContainer = ({ onRetryFlyerUpload }) => {
  const event = useSelector(eventSelector)
  const eventModal = useSelector(eventModalSelector)

  const renderFlyer = () => {
    return <Flier event={event} onRetryFlyerUpload={onRetryFlyerUpload} />
  }

  const isGroupVisible = eventModal === 'chat'

  return (
    <div className={styles['flyer-container']}>
      {renderFlyer()}
      {isGroupVisible && <ChatSection />}
    </div>
  )
}

FlyerContainer.propTypes = {
  onRetryFlyerUpload: PropTypes.func
}

export default FlyerContainer
